import { useMemo } from 'react';
import { useCollapse } from 'react-collapsed';
import { EXPANDING_ANIMATION, EXPANDING_DURATION_MS } from '../constants';
export const useExpandCollapse = (expanded) => {
    const { getCollapseProps, isExpanded } = useCollapse({
        isExpanded: expanded ?? true,
        duration: EXPANDING_DURATION_MS,
        easing: EXPANDING_ANIMATION,
    });
    return useMemo(() => ({ getCollapseProps, isExpanded }), [getCollapseProps, isExpanded]);
};
